import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { API } from "aws-amplify";

import {
  getConfigAS,
  getConfigRI,
  getConfigRG,
  getConfigIG,
  getConfigUC,
} from "../../../Store/config/actions";
import {
  alert,
  errortext,
  modalError,
  modalSteps,
  stateAlert,
} from "../../../Store/simulate/actions";

import Button from "../../../Components/FormElements/Button";
import ModalFiltering from "../../../Components/FormElements/ModalFiltering";

const modalRechazar = ({ product, moneda }: any) => {
  const [enableButton, setEnableButton] = useState<any>(true);
  const quoteDataModal = useSelector(
    (state: any) => state.quote.policy.quoteDataModal
  );

  const inputEl: any = useRef(null);
  const monedaQuestions = moneda.iso === "USD" ? 0 : 1;
  let history = useHistory();
  const dispatch = useDispatch();
  const config = useSelector((state: any) => state.config[product]);
  const [loadingClick, setLoadingClick] = useState(false);

  const getOptions = () => {
    if (
      config[monedaQuestions] &&
      config[monedaQuestions].reasonRejection.length !== 0
    ) {
      const filterQuestions = config[monedaQuestions].reasonRejection.map(
        (el: any) => el
      );
      return filterQuestions || [];
    }
    return [];
  };

  useEffect(() => {
    if (!getOptions()) {
      const fetchData = async function () {
        switch (product) {
          case "AS":
            await getConfigAS(dispatch);
            break;
          case "RI":
            await getConfigRI(dispatch);
            break;
          case "RG":
            await getConfigRG(dispatch);
            break;
          case "IG":
            await getConfigIG(dispatch);
            break;
          case "UC":
            await getConfigUC(dispatch);
            break;
          default:
            console.log("No hay producto");
            break;
        }
      };
      fetchData();
    }
  }, []);

  const [formValues, setFormValues] = useState<any>({
    comment: "",
    reason: null,
  });

  const { reason, comment } = formValues;

  const handleInputChange = ({ target }: any) => {
    setFormValues({
      ...formValues,

      [target.name]: target.value,
    });
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();

    if (reason === "Otros" && !isValidForm()) {
      return;
    }
    const data = {
      comment,
      reason,
    };
    setLoadingClick(true);
    const params = {
      quoteId: quoteDataModal.body.idCotizacion,
      ...data,
    };
    const response = await API.post("api-rentas", "/reject-quote", {
      body: params,
    });
    if (response.status) {
      history.push("/aprobaciones");
      dispatch(modalSteps(false));
      dispatch(stateAlert(true));
      dispatch(
        alert({
          type: "danger",
          title: "¡Cotización rechazada!",
          message: "La póliza no será emitida",
        })
      );
      setLoadingClick(false);
    } else {
      dispatch(modalError(true));
      dispatch(errortext("default"));

      setLoadingClick(false);
      dispatch(modalSteps(false));
    }
  };

  const isValidForm = () => {
    if (comment.trim().length === 0 || reason === null) {
      setEnableButton(true);
      return false;
    }
    setEnableButton(false);
    return true;
  };

  useEffect(() => {
    // Si no se ha seleccionado ningún motivo, deshabilitar el botón
    if (reason === null) {
      setEnableButton(true);
      return;
    }

    // Si se seleccionó "Otros", validar que haya comentario
    if (reason === "Otros") {
      if (comment.trim().length === 0) {
        setEnableButton(true); // deshabilitar botón
      } else {
        setEnableButton(false); // habilitar botón
      }
    } else {
      // Para cualquier otro motivo, habilitar el botón
      setEnableButton(false);
    }
  }, [comment, reason]);

  return (
    <div className="modal-rechazar">
      <ModalFiltering className="modal-result is-midle" variant={loadingClick}>
        <h2 className="modal-result__title">
          ¿Quieres rechazar la cotización?
        </h2>
        <div className="modal-result__desc">
          Esta acción no se podrá revertir y volverás al{" "}
          <span>listado de aprobaciones.</span>
        </div>
        <form ref={inputEl} onSubmit={handleSubmit}>
          <div className="clientForm__control input-field">
            <select
              className="browser-default"
              id="reason"
              name="reason"
              value={reason}
              onChange={handleInputChange}
            >
              <option value="" disabled selected>
                Selecciona motivo
              </option>
              {getOptions() !== undefined &&
                getOptions().map((item: any, index: number) => (
                  <option value={item} key={index}>
                    {item}
                  </option>
                ))}
            </select>
          </div>
          <div className="question__control__textarea input-field">
            <textarea
              name="comment"
              value={comment}
              className={`materialize-textarea ${
                reason === null ? "disabled" : ""
              } ${
                comment !== '' ? "materialize-textarea-with-content" : ""
              }`}
              maxLength={500}
              disabled={reason === null}
              onChange={handleInputChange}
            ></textarea>
            { comment == '' && <label>Agrega un comentario {reason === "Otros" ? "(requerido)" : "(opcional)"}</label> }
          </div>
          <div className="actions">
            <Button
              type="submit"
              className={`${
                loadingClick ? "is-loading" : ""
              } actions__continue`}
              disabled={enableButton}
            >
              Rechazar
            </Button>
            <Button
              type="button"
              className="is-secondary actions__cancel"
              onClick={() => dispatch(modalSteps(false))}
              disabled={loadingClick ? true : false}
            >
              Cancelar
            </Button>
          </div>
        </form>
      </ModalFiltering>
    </div>
  );
};

export default modalRechazar;
